@let configValue = config();
@let loadingValue = loading();
@let uploadingValue = uploading();

<pct-feature-file-upload-native-component
  [config]="configValue"
  [disabled]="effectiveDisabled()"
  [nameAttribute]="nameAttribute()"
  (dragOver)="onDragOver($event)"
  (filesSelect)="onFileSelect($event)"
>
  <ng-template #dropZoneContentTpl>
    @let hasError =
      loadingValue === false &&
      uploadingValue === false &&
      ngControl.touched === true &&
      ngControl.control?.errors !== null;
    <pct-feature-file-upload-material-file-drop-zone-content
      [config]="configValue"
      [dragOver]="dragOver()"
      [hasError]="hasErrorFromOutside() || hasError"
      [hideCardShadow]="hideCardShadow()"
      [i18nScope]="effectiveI18nScope()"
      [loading]="loadingValue"
      [uploading]="uploadingValue"
    />
    @if (hasError) {
      <mat-error [control]="ngControl.control!" />
    }
  </ng-template>
  <ng-template #fileListContentTpl>
    @let fileListContentValue = fileListContent();
    @if (fileListContentValue !== undefined) {
      <ng-container
        *ngTemplateOutlet="
          fileListContentValue;
          context: {
            config: configValue,
            disabled: effectiveDisabled(),
            i18nScope: effectiveI18nScope(),
            loading: loadingValue,
            uploading: uploadingValue,
            onRemove: onRemove,
          }
        "
      />
    } @else {
      <pct-feature-file-upload-material-file-list
        [config]="configValue"
        [disabled]="effectiveDisabled()"
        [files]="effectiveSelectedFiles().files"
        [hideCardShadow]="hideCardShadow()"
        [i18nScope]="effectiveI18nScope()"
        [loading]="loadingValue"
        [uploading]="uploadingValue"
        (remove)="onRemove($event)"
      />
    }
  </ng-template>
</pct-feature-file-upload-native-component>
